"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProgressRing = function ProgressRing(props) {
  var radius = props.radius;
  var stroke = props.stroke;
  var normalizeRadius = radius - stroke * 2;
  var circumference = normalizeRadius * 2 * Math.PI;
  var value = props.value;
  var total = props.total;
  var _getColor = function _getColor(score) {
    if (score < 80) {
      return '#d03916';
    }
    return '#3673b6';
  };
  var strokeDashoffset = circumference - value / total * circumference;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, !props.dontShowPercent && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].percent,
    style: {
      fontSize: "".concat(radius / 2 - 2, "px"),
      color: _getColor(value)
    }
  }, Math.round(value / total * 100), "%"), /*#__PURE__*/_react["default"].createElement("svg", {
    className: _style["default"].progressRing,
    width: radius * 2,
    height: radius * 2
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    className: _style["default"].circleBg,
    stroke: "#eee",
    strokeWidth: "4",
    fill: "transparent",
    r: normalizeRadius,
    cx: radius,
    cy: radius
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: _style["default"].circle,
    strokeDasharray: circumference + ' ' + circumference,
    style: {
      strokeDashoffset: strokeDashoffset
    },
    stroke: _getColor(value),
    strokeWidth: "4",
    fill: "transparent",
    r: normalizeRadius,
    cx: radius,
    cy: radius
  })));
};
ProgressRing.propTypes = {
  value: _propTypes["default"].number.isRequired,
  total: _propTypes["default"].number,
  radius: _propTypes["default"].number,
  stroke: _propTypes["default"].number,
  dontShowPercent: _propTypes["default"].bool
};
ProgressRing.defaultProps = {
  total: 100,
  radius: 20,
  stroke: 4,
  dontShowPercent: false
};
var _default = exports["default"] = ProgressRing;